/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddTeamTestDto } from '../models/AddTeamTestDto';
import type { ObjectResponseDto } from '../models/ObjectResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MatchService {
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static matchControllerRefresh({
        id,
        tid,
    }: {
        id: string,
        tid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/teams/{tid}/refresh',
            path: {
                'id': id,
                'tid': tid,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static matchControllerGet({
        id,
        hid,
        cid,
    }: {
        id: string,
        hid: string,
        cid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/hiring/{hid}/candidates/{cid}/match',
            path: {
                'id': id,
                'hid': hid,
                'cid': cid,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static matchControllerListTeamTests({
        id,
        tid,
    }: {
        id: string,
        tid: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/teams/{tid}/tests',
            path: {
                'id': id,
                'tid': tid,
            },
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static matchControllerAddTeamTest({
        id,
        tid,
        requestBody,
    }: {
        id: string,
        tid: string,
        requestBody: AddTeamTestDto,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/teams/{tid}/tests',
            path: {
                'id': id,
                'tid': tid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ObjectResponseDto
     * @throws ApiError
     */
    public static matchControllerRemoveTeamTest({
        id,
        tid,
        testId,
    }: {
        id: string,
        tid: string,
        testId: string,
    }): CancelablePromise<ObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/companies/{id}/teams/{tid}/tests/{testId}',
            path: {
                'id': id,
                'tid': tid,
                'testId': testId,
            },
        });
    }
}
